import { Component, Input, OnInit } from '@angular/core';

@Component({
	selector: 'cmv-steps',
	templateUrl: './steps.component.html',
	styleUrls: ['./steps.component.scss'],
})
export class StepsComponent implements OnInit {
	@Input() numberSteps: number = 1;
	@Input() stepActive: number = 0;

	steps: number[] = [];

	constructor() {}

	ngOnInit(): void {
		for (let index = 0; index < this.numberSteps; index++) {
			this.steps.push(index);
		}
	}
}
